import pt from "./pt.json";
import en from "./en.json";

const messages = {
  pt: {
    translations: pt,
  },
  "pt-PT": {
    translations: pt,
  },
  en: {
    translations: en,
  },
  "en-US": {
    translations: en,
  },
};

export { messages };
